module.exports = __webpack_public_path__ + "img/donut-cat.3e752564.png";